module.exports = __webpack_public_path__ + "static/media/15.e545e119.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/moan/15.mp3
// module id = 491
// module chunks = 0